module["exports"] = [
  "#{street_name} no #{building_number}"
];